// extracted by mini-css-extract-plugin
export default {"wrapper":"StimulationSites_wrapper__2bMAE","column":"StimulationSites_column__64kc7"};